import React from 'react';

import { Field } from 'formik';

import DisabledCheckbox from '../../../components/svgs/DisabledCheckbox';
import DeviceObject from '../../../components/DeviceObject';

const DeviceFormItems = ({ devices }) => (
  devices.map(device => (
    <div key={device.serialNumber} className="card-group__item">
      <div className="card card--secondary card--action-right-at-768 card--form-control">
        <div className="card__content">
          <div className="form-control form-control--boolean">
            <div className="form-control__input">
              {!device.customerOwned && (
                <Field
                  component="input"
                  id={`selectedDevices-${device.serialNumber}`}
                  type="checkbox"
                  name="selectedDevices"
                  value={`${device.serialNumber}`}
                />
              )}
              {device.customerOwned && <DisabledCheckbox />}
              <label className="form-control__label align-items-center" htmlFor={`selectedDevices-${device.serialNumber}`}>
                <DeviceObject device={device} showSummary />
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  ))
);

export default DeviceFormItems;
